import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {HttpSearchRepository} from '../Repositories/HttpSearchRepository.js'
import {GetSearchRequestFromAISearchRequest} from '../Request/GetSearchRequestFromAISearchRequest.js'

class GetSearchRequestFromAISearchUseCase extends UseCase {
  #config
  #repository

  static create({config}) {
    return new GetSearchRequestFromAISearchUseCase({
      config,
      repository: HttpSearchRepository.create({config})
    })
  }

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  @tracer({metric: 'GetSearchRequestFromAISearchUseCase#execute'})
  @AsyncInlineError()
  async execute({query, listingSectionId, variant} = {}) {
    try {
      const [error, response] = await this.#repository.getSearchRequestFromAI({
        config: this.#config,
        searchRequest: GetSearchRequestFromAISearchRequest.createFromSearch({
          config: this.#config,
          listingSectionId,
          query
        }),
        variant
      })

      return error
        ? Promise.reject(
            DomainSharedError.isDomainError({error})
              ? error
              : DomainSharedError.createGenericError({config: this.#config, cause: error})
          )
        : response
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({config: this.#config, cause: error}))
    }
  }
}

export const factory = GetSearchRequestFromAISearchUseCase.create
